export const RED = "#ff7979"
export const GREEN = "success"
export const BLUE = "#6a89cc"